import { render, staticRenderFns } from "./QInputNumber.vue?vue&type=template&id=651e572e&"
import script from "./QInputNumber.vue?vue&type=script&lang=js&"
export * from "./QInputNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports